'use client'

import { motion } from 'framer-motion'
import Link from 'next/link'

export function PhaseBlueprint() {
  return (
    <section id="blueprint" className="py-16 md:py-24 scroll-mt-16">
      <div className="container max-w-7xl mx-auto px-6">
        <div className="backdrop-blur-2xl bg-white/[0.03] border border-[#3e4658] rounded-[40px] lg:rounded-[60px] p-8 md:p-12 lg:p-16">
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-[#61d8fe] text-lg font-anuphan mb-4"
          >
            Phase 1 — $999
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-white text-3xl md:text-[48px] font-normal leading-[1.1] font-gendy mb-6"
          >
            The Blueprint
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-white text-xl md:text-[26px] leading-[1.4] font-anuphan mb-4 max-w-[900px]"
          >
            Before we build the engine, we map the blueprint. This is a highly personalized diagnostic — not a sales pitch disguised as a workshop.
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.15 }}
            className="text-[#bdbdbd] text-lg md:text-[22px] leading-[1.5] font-anuphan mb-12 max-w-[800px]"
          >
            We uncover exactly where your business is bleeding time and capital — and how AI fixes it. You leave with a plan your team can execute on Monday morning.
          </motion.p>

          <motion.h3
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-white text-2xl md:text-[34px] font-normal font-gendy mb-8"
          >
            What you get
          </motion.h3>

          <div className="grid md:grid-cols-2 gap-x-12 gap-y-6 mb-12">
            {[
              {
                title: 'Intelligent Pre-Assessment',
                desc: "We don't waste your time asking basic questions. Using proprietary web-scraping, we analyze your public-facing business footprint before we even speak — so our time together is surgical."
              },
              {
                title: 'The Executive Masterclass',
                desc: 'A 4-hour, live, in-person intensive tailored to your operational realities. Not theory. We pull back the curtain on how elite companies are leveraging automation today — and show you what applies to yours.'
              },
              {
                title: 'Your Private Command Center',
                desc: 'A custom, secure dashboard hosted on a dedicated beHMN subdomain. Your comprehensive process map, assessment results, and step-by-step how-to guides — so your team can start executing immediately.'
              },
            ].map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                className="flex gap-4"
              >
                <div className="flex-shrink-0 w-2 h-2 rounded-full bg-[#61d8fe] mt-2.5" />
                <div>
                  <p className="text-white font-semibold font-anuphan mb-1">{item.title}</p>
                  <p className="text-[#8a8f9e] text-sm font-anuphan leading-relaxed">{item.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>

          <a
            href="https://calendly.com/alex-behmn/discovery-call"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#544ae8] border border-[#475065] rounded-[100px] px-10 py-4 text-white text-lg font-anuphan hover:scale-[1.02] active:scale-[0.98] transition-transform"
          >
            Get Your Blueprint
          </a>
        </div>
      </div>
    </section>
  )
}
